var store = {
  state: {
    isLogin: false,
    currentRoute: '',
    currentTab: 0,
    navList: [
      {
        name: '首頁',
        link: '#home-page',
        bgImageUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-1.png',
        bgImageActiveUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-1-active.png',
        bgImageUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-1--mobile.png',
        bgImageActiveUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-1-active--mobile.png',
      },
      {
        name: '新聞資訊',
        link: '#page-news',
        bgImageUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-2.png',
        bgImageActiveUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-2-active.png',
        bgImageUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-2--mobile.png',
        bgImageActiveUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-2-active--mobile.png',
      },
      {
        name: '玩家社群',
        link: '#page-face',
        bgImageUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-3.png',
        bgImageActiveUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-3-active.png',
        bgImageUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-3--mobile.png',
        bgImageActiveUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-3-active--mobile.png',
      },
      {
        name: '遊戲特色',
        link: '#page-role',
        bgImageUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-4.png',
        bgImageActiveUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-4-active.png',
        bgImageUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-4--mobile.png',
        bgImageActiveUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-4-active--mobile.png',
      },
      {
        name: '儲值中心',
        link: 'order',
        bgImageUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-5.png',
        bgImageActiveUrl:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-5-active.png',
        bgImageUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-5--mobile.png',
        bgImageActiveUrlMobile:
          'https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/nav-5-active--mobile.png',
      },
    ],
  },
};

export default store;
